export default "__VITE_ASSET__Bx0C05bq__"